namespace Nobox.CRM {
    export interface ProductsRow {
        Id?: number;
        IdExternal?: number;
        TnId?: number;
        ProductName?: string;
        Currencies?: string;
        PriceList?: number;
        Quantity?: number;
        Discount?: number;
        TotalPrice?: number;
        FinalTotalPrice?: number;
        Image?: string;
        Tags?: string;
        ProductDesc?: string;
        ProductCode?: string;
        UnitIds?: string;
        ManufacturIds?: string;
        IdExt?: string;
        Extra?: string;
        IsShowForm?: number;
        Custom?: string;
        In?: string;
        InBy?: number;
        Up?: string;
        UpBy?: number;
    }

    export namespace ProductsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'Nobox.Products';
        export const lookupKey = 'Nobox.Products';

        export function getLookup(): Q.Lookup<ProductsRow> {
            return Q.getLookup<ProductsRow>('Nobox.Products');
        }
        export const deletePermission = 'Deals:Delete';
        export const insertPermission = 'Deals:Modify';
        export const readPermission = 'Deals:View';
        export const updatePermission = 'Deals:Modify';

        export declare const enum Fields {
            Id = "Id",
            IdExternal = "IdExternal",
            TnId = "TnId",
            ProductName = "ProductName",
            Currencies = "Currencies",
            PriceList = "PriceList",
            Quantity = "Quantity",
            Discount = "Discount",
            TotalPrice = "TotalPrice",
            FinalTotalPrice = "FinalTotalPrice",
            Image = "Image",
            Tags = "Tags",
            ProductDesc = "ProductDesc",
            ProductCode = "ProductCode",
            UnitIds = "UnitIds",
            ManufacturIds = "ManufacturIds",
            IdExt = "IdExt",
            Extra = "Extra",
            IsShowForm = "IsShowForm",
            Custom = "Custom",
            In = "In",
            InBy = "InBy",
            Up = "Up",
            UpBy = "UpBy"
        }
    }
}
